<section class="flex flex-col items-center gap-12">
  <ng-content select="[slot=header]">
    <app-section-header
      [description]="'Our customers love Capawesome Cloud - find out why'"
      [icon]="'@tui.medal'"
      [subtitle]="'Succes Stories'"
      [title]="'See what our customers say'"
    ></app-section-header>
  </ng-content>
  <div class="w-full">
    @defer {
      <tui-carousel
        [duration]="duration()"
        [(index)]="index"
        [style.--tui-carousel-padding]="0"
      >
        @for (item of testimonials(); track item.person.name) {
          <div
            *tuiItem
            class="to-background-neutral-2 flex flex-col gap-6 rounded-[--tui-radius-l] bg-gradient-to-r from-background-neutral-1 p-4 md:p-6"
          >
            <div>
              @if (item.company.url) {
                <a
                  [href]="item.company.url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    [alt]="item.company.name"
                    class="h-12 md:h-14"
                    [src]="item.company.imgSrc"
                  />
                </a>
              } @else {
                <img
                  [alt]="item.company.name"
                  class="h-12 md:h-14"
                  [src]="item.company.imgSrc"
                />
              }
            </div>
            <p class="text-lg" [innerHTML]="item.quote"></p>
            <div class="flex items-center gap-4">
              @if (item.person.imgSrc) {
                <img
                  [alt]="item.person.name"
                  class="h-12 w-12 rounded-full"
                  [src]="item.person.imgSrc"
                />
              }
              <div class="flex flex-col">
                <span class="text-lg font-bold">
                  {{ item.person.name }}
                </span>
                <span class="text-base">
                  {{ item.person.position }} at {{ item.company.name }}
                </span>
              </div>
            </div>
          </div>
        }
      </tui-carousel>
      <tui-pagination
        size="s"
        class="mt-4"
        [length]="testimonials().length"
        [(index)]="index"
      />
    } @placeholder {
      <div
        class="h-64 w-full animate-pulse rounded-[--tui-radius-l] bg-gray-200"
      ></div>
    }
  </div>
</section>
